import Carousel from 'react-bootstrap/Carousel';


function UncontrolledExample() {
  return (
    <Carousel>
     <Carousel.Item>
       <img className='img-carousel' src="carrousel1.png" alt="" />
        <Carousel.Caption>
        
        </Carousel.Caption>
      </Carousel.Item>
       <Carousel.Item>
       <img className='img-carousel' src="carrousel2.png" alt="" />
        <Carousel.Caption>
        
       </Carousel.Caption>
      </Carousel.Item>

      {/* 
      <Carousel.Item>
       <img className='img-carousel' src="dorsos2.png" alt="" />
        <Carousel.Caption>
        
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
     <img className='img-carousel2' src="3cartasazules.png" alt="" />
        <Carousel.Caption>
         
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
     <img className='img-carousel2' src="3cartasrojas.png" alt="" />
        <Carousel.Caption>
         
        </Carousel.Caption>
         
      </Carousel.Item>
   */}
     
      
    </Carousel>
  );
}

export default UncontrolledExample;